<template>
  <h3>{{ data && data.dataName }}</h3>
  
  <span style="color:rgba(95, 95, 95, 0.918)">
    <el-icon><Clock /></el-icon>
    {{ data && data.uploadTime }}
    </span>
</template>

<script setup>
import { ref, onMounted } from "vue";
import $ from "jquery";
import { useRoute } from "vue-router";
import { ElMessage } from "element-plus";


const Route = useRoute();
const courseId = ref("");
const videoId = ref("");
const data = ref("");


onMounted(() => {
  courseId.value = Route.params.courseId;
  videoId.value = Route.params.videoId;
  pullData();

});

// 拉取数据
const pullData = () => {
  const token = localStorage.getItem("token");
  $.ajax({
    url: "http://124.222.105.205:5000/api/data/getDataByVid",
    data: {
        videoId: videoId.value,
    },
    type: "post",
    headers: {
      Authorization: "Bearer " + token,
    },
    success(resp) {
      if (resp.code == "200") {
        data.value = resp.data;
      } else {
        ElMessage({
          type: "error",
          message: resp.msg,
        });
      }
    },
    error() {
      ElMessage({
        type: "error",
        message: "拉取数据失败",
      });
    },
  });
};

</script>

<style>

</style>